import React from 'react';

const LambdaErrorGray = ({
  width = '12',
  height = '12',
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      {...rest}
    >
      <circle cx="6.5" cy="6" r="5.5" stroke="#C2C2C2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62998 7.96472V8.50317C5.62998 8.63417 5.48256 8.71495 5.3649 8.646L5.10797 8.48582L5.0462 8.45199L3.90976 7.81416L3.84813 7.77985C3.78398 7.7439 3.73132 7.69244 3.69492 7.63031C3.65894 7.56869 3.64022 7.49876 3.64092 7.42941L3.64062 6.08845V4.74534C3.64062 4.66994 3.66256 4.59632 3.70333 4.53314C3.74373 4.46965 3.80223 4.41747 3.86219 4.38939L4.98293 3.76062L5.04428 3.72576L5.106 3.69156L6.17934 3.09001L6.24221 3.05386C6.31127 3.01524 6.38944 2.99686 6.4687 3.00044C6.54563 3.00406 6.62147 3.02854 6.6736 3.06466L7.79052 3.69123L7.85242 3.72514L8.98811 4.36258L9.05014 4.39702C9.11427 4.43305 9.16679 4.48445 9.20317 4.54656C9.23907 4.60802 9.25779 4.67793 9.25718 4.74749L9.25742 5.96856C9.25744 6.09817 9.11284 6.17916 8.99723 6.11429L8.51524 5.84383C8.46164 5.81375 8.42863 5.75822 8.42863 5.69813V4.97699L7.45973 4.43306C7.45057 4.42865 7.43176 4.41824 7.37779 4.38788L6.44896 3.86601L5.48326 4.4074L5.46781 4.41714C5.46417 4.41932 5.39793 4.45663 5.39793 4.45663L4.46947 4.97706V7.19984L5.43892 7.74401C5.44585 7.74738 5.4585 7.75441 5.52248 7.79026L5.54945 7.8135L5.56441 7.83291C5.60556 7.86461 5.62998 7.91304 5.62998 7.96472ZM5.45475 7.9702L5.45312 7.96875C5.45356 7.96932 5.45411 7.96981 5.45475 7.9702ZM8.68794 6.43508C8.57234 6.37045 8.42799 6.45143 8.42799 6.58092V6.68009L5.97124 5.30199L5.88761 5.2547C5.8041 5.20791 5.70106 5.2128 5.62332 5.2665L5.55896 5.30164L5.19137 5.50702L5.04312 5.58964C4.92446 5.65625 4.88735 5.80205 4.95661 5.91804L5.04088 6.05912L5.12591 6.20173C5.19467 6.31684 5.34518 6.35275 5.46431 6.28511C5.60943 6.20379 5.61627 6.19998 5.62273 6.1956C5.62331 6.19521 5.62389 6.19481 5.62457 6.19435L5.76423 6.11648L6.04368 6.27326L6.04339 8.89035C6.04339 9.02133 6.15276 9.12755 6.28769 9.12755C6.34958 9.12755 6.40875 9.10488 6.45392 9.06426L6.78305 8.80622C6.84659 8.75652 6.88002 8.67965 6.87309 8.60112L6.8736 6.7391L8.63097 7.72801C8.75368 7.79663 8.8904 7.75066 8.98183 7.63721L9.20742 7.41416C9.2391 7.38264 9.25678 7.34047 9.25678 7.29656V6.8504C9.25678 6.79021 9.22367 6.73461 9.16994 6.70457L8.68794 6.43508Z"
        fill="#C2C2C2"
      />
    </svg>
  );
};

export default LambdaErrorGray;
